import { render, staticRenderFns } from "./geography.vue?vue&type=template&id=47279118&"
import script from "./geography.vue?vue&type=script&lang=js&"
export * from "./geography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports